export const getNewAddress = () => ({
    purpose: 'main',
    country: null,
    address_1: null,
    address_2: null,
    address_3: null,
    city: null,
    state_province: null,
    zip: null,
    preferred_billing: true,
    preferred_mailing: true,
    preferred_shipping: true,
});
